import { exposeClassnames as classnames } from '@stadionhq-v3/utilities';
import { PROFILE_POSITIONS } from '@stadionhq-v3/core';
import { PlayerProfileCardProps } from './profileCard.types';
import styles from './profileCard.module.scss';

const ProfileCard = ({
  style = 'complex',
  url,
  image,
  hoverImage,
  flag,
  showFlagInFooter,
  squadNumber,
  firstName,
  surname,
  knownAs,
  position,
  caps,
  nativeProps,
  classNames,
}: PlayerProfileCardProps) => {
  const classes = classnames([styles.tokens, styles.profileCard], classNames, {
    [`${styles.hasHoverImage}`]: hoverImage,
    [`${styles.simple}`]: style === 'simple',
  });

  const isStaff = position?.toLowerCase() === PROFILE_POSITIONS.STAFF;

  return (
    <div {...nativeProps} className={classes} data-component="ProfileCard">
      <a href={url}>
        <div className={classnames(styles.playerImageContainer)}>
          {image && <div className={classnames(styles.image)}>{image}</div>}

          {hoverImage && (
            <div className={classnames(styles.hoverImage)}>{hoverImage}</div>
          )}

          <div className={classnames(styles.contentRight)}>
            {flag && !showFlagInFooter && (
              <div className={classnames(styles.flag)}>{flag}</div>
            )}
            <span className={classnames(styles.position)}>{position}</span>
          </div>
        </div>

        <div className={classnames(styles.playerDetails)}>
          {caps ? (
            <span className={classnames(styles.caps)}>
              <span className={classnames(styles.capsLabel)}>Caps</span>
              <span className={classnames(styles.capsValue)}>{caps}</span>
            </span>
          ) : (
            !isStaff &&
            squadNumber &&
            style === 'complex' && (
              <span className={classnames(styles.squadNumber)}>
                {squadNumber}
              </span>
            )
          )}
          <div className={classnames(styles.nameContainer)}>
            {knownAs ? (
              <span className={classnames(styles.knownAs)}>{knownAs}</span>
            ) : (
              <>
                <span className={classnames(styles.firstName)}>
                  {firstName}
                </span>
                <span className={classnames(styles.surname)}>{surname}</span>
              </>
            )}
          </div>

          {flag && showFlagInFooter && (
            <div className={classnames(styles.flag)}>{flag}</div>
          )}
        </div>
      </a>
    </div>
  );
};

export default ProfileCard;
